import React, { useEffect } from 'react'
import ReviewList from '../../../../Components/Review/ReviewList'
import Footer from '../../../../Components/Footer/Footer'

const data = Array.from({ length: 15 }).map((_) => ({
  rating: 4,
  time: new Date(0).getTime(),
  reviewer: {
    name: 'Randy Singleton',
    image: 'https://unsplash.it/600?random',
  },
  review: `Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consectetur
        corporis culpa, cumque dolor explicabo id illo magnam natus non ratione
        repellendus sed tenetur, voluptate. Aperiam architecto corporis debitis
        esse excepturi neque optio perspiciatis quas. Consequatur delectus eaque
         exercitationem facere id nemo officiis pariatur, perferendis provident
         rerum tempore veniam veritatis voluptas.`,
}))

const Reviews = () => {
  useEffect(() => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' })
  }, [])
  return (
    <div className='allReviews'>
      <h1 className={'sectionSubTitle'}>Student feedback</h1>
      <ReviewList data={data} />
      <Footer />
    </div>
  )
}

export default Reviews
